import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import TabbarOption from "../../component/tabbarOption";
import FlatlistFinal from "../../component/flatlistFinal";
import Modal from "modal-react-native-web";
import { tokenState, userState } from "../../reducer/recoil";
import { useRecoilState } from "recoil";
import {
  getFinalAthlete,
  registerformfinal,
  getFinalOffice,
  approbationsregisterform,
  deleteFinalAth,
} from "../../action/authAction";
import { useIsFocused } from "@react-navigation/native";
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";
import moment from "moment";
import { apiservice } from "../../service";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, route }) {
  const [token, setToken] = useRecoilState(tokenState);
  const [showModal, setShowModal] = useState(false);
  const [approve, setApprove] = useState(false);
  const [profile, setProfile] = useRecoilState(userState);
  const [data, setData] = React.useState([]);
  const [filterdata, setfilterData] = React.useState([]);
  const [text, setText] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [dataSelect, setDataSelect] = React.useState([]);
  const [dataofficialSelect, setDataOfficialSelect] = React.useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [validate, setValidate] = useState("");

  console.log("params , ", route.params);
  const [modal, setModal] = useState(false);
  const focus = useIsFocused();
  const [DATA, SETDATA] = useState([]);

  async function callApi() {
    const response = await getFinalAthlete({
      token: token.token,
      body: route.params.competition_id,
      body2: profile.profile.Association.association_id,
    });
    let Arr = [];

    var results = await Promise.all(
      response.result.map(async (item) => {
        const resposnes = await apiservice({
          path:
            "/athletes/current_score?athlete_id=" +
            item.athlete_id +
            "&competition_id=" +
            route.params.competition_id,
          method: "get",
          token: token.token,
        });
        if (item.official_id != null) {
          Arr = Arr.concat({
            ...item,
            Athlete: item.Officials,
          });
        } else {
          Arr = Arr.concat({
            ...item,
            Athlete: {
              ...item.Athlete?.[0],
            },
          });
        }
      })
    );

    const responseRegister = await approbationsregisterform({
      body: route.params.competition_id,
      path: profile.profile.Association.association_id,
      token: token.token,
    });

    if (response.result) {
      setData(Arr);
      setDataSelect(
        response.result.map(
          (item) => item.athlete_id != null && item.athlete_id
        )
      );
      setDataOfficialSelect(
        response.result.map(
          (item) => item.official_id != null && item.official_id
        )
      );
    }
  }

  let body = {
    approbation_id: route.params.approbation_id,
    competition_id: route.params.competition_id,
    final_entry_athletes: [],
    final_entry_officials: [],
  };

  if (profile.profile != undefined) {
    body.association_id = profile.profile.Association.association_id;
  }

  React.useEffect(() => {
    if (profile.profile != undefined) {
      setfilterData((val) =>
        val.concat(route.params.events_male).concat(route.params.events_female)
      );

      if (DATA.length == 0) {
        SETDATA((val) =>
          val
            .concat(
              route.params.events_male.map((item) => ({
                event: item,
                gender: "Male",
                Type: "Athlete",
              }))
            )
            .concat(
              route.params.events_female.map((item) => ({
                event: item,
                gender: "Female",
                Type: "Athlete",
              }))
            )
        );

        if (route.params.approbation_details.official_male_numbers > 0) {
          SETDATA((val) =>
            val.concat([
              { event: "Official", gender: "Male", Type: "Official" },
            ])
          );
        }
        if (route.params.approbation_details.official_female_numbers > 0) {
          SETDATA((val) =>
            val.concat([
              { event: "Official", gender: "Female", Type: "Official" },
            ])
          );
        }
      }

      SETDATA((val) =>
        val.sort((a, b) => {
          if (a.event.toLowerCase() < b.event.toLowerCase()) return -1;
          if (a.event.toLowerCase() > b.event.toLowerCase()) return 1;
          return 0;
        })
      );
      callApi();
    }
  }, [focus, profile]);

  return (
    <View style={styles.container}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          // Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
          <View style={styles.viewModal}>
            <Text style={styles.textModal}>{validate}</Text>
          </View>
        </View>
      </Modal>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorCompetition="#FFFFFF"
        User
        navigation={navigation}
      />

      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITIONS/${route.params.name}/FINAL ENTRY SUBMIT`}
          />
          {filterdata.length > 0 && (
            <TabbarOption
              filterdata={filterdata.map((item) => {
                return { label: item, value: item };
              })}
              onfilter={(val) => console.log(val)}
              onEvent={(value) => {
                console.log(value);
              }}
              setGender={(val) => {
                if (val != "GENDER") {
                  setGender(val);
                } else {
                  setGender("");
                }
              }}
              onChangeText={(text) => {
                setText(text);
              }}
              FinalUser
              buttonTabbar
            />
          )}
          {width >= 1280 && (
            <View
              style={{
                flexDirection: "row",
                paddingHorizontal: 38.5,
                marginTop: 35,
                width: "100%",

                justifyContent: "space-between",
              }}
            >
              <View
                style={{
                  width: "20%",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text
                  numberOfLines={1}
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                    { width: "50%" },
                  ]}
                >
                  EVENTS
                </Text>
                <Text
                  numberOfLines={1}
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                    { width: "50%" },
                  ]}
                >
                  MEMBER
                </Text>
              </View>
              <View
                style={{
                  width: "80%",

                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={{ width: "10%" }}>
                  <Text
                    style={[
                      width < 1600 ? styles.textTopicRespons : styles.textTopic,
                      {
                        maxWidth: width < 1600 ? 100 : 120,
                        width: "100%",
                      },
                    ]}
                  >
                    IMAGE
                  </Text>
                </View>
                <Text
                  numberOfLines={1}
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                    {
                      textAlign: "center",
                      width: "15%",
                    },
                  ]}
                >
                  NAME
                </Text>
                <Text
                  numberOfLines={1}
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                    ,
                    {},
                  ]}
                >
                  BIRTH
                </Text>
                <Text
                  numberOfLines={1}
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                  ]}
                >
                  PASSPORT
                </Text>

                <Text
                  numberOfLines={1}
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                    ,
                    { width: "12%" },
                  ]}
                >
                  PERSONAL BEST
                </Text>
                <Text
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                  ]}
                >
                  SEASON BEST
                </Text>
                <Text
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                    { width: "7%" },
                  ]}
                />
                <Text
                  style={[
                    width < 1600 ? styles.textTopicRespons : styles.textTopic,
                    { width: "7%" },
                  ]}
                />
              </View>
            </View>
          )}

          {/*((item.gender == "Male" &&
                  route.params.approbation_details.events_male[item.event] >
                    0) ||
                  (item.gender != "Male" &&
                    route.params.approbation_details.events_female[item.event] >
                0)) && */}

          <FlatList
            data={DATA?.filter((item) => {
              if (item?.gender == "Male") {
                if (item?.event == "Official") {
                  return (
                    route.params.approbation_details.official_male_numbers > 0
                  );
                } else {
                  return route.params.approbation_details.events_male[
                    item.event
                  ];
                }
              } else {
                if (item?.event == "Official") {
                  return (
                    route.params.approbation_details.official_female_numbers > 0
                  );
                } else {
                  return route.params.approbation_details.events_female[
                    item.event
                  ];
                }
              }
            })}
            numColumns={1}
            extraData={[data]}
            scrollEnabled={false}
            renderItem={({ index, item }) => {
              return (
                <View
                  style={{
                    flexDirection: "row",
                    paddingHorizontal: 38.5,
                    width: "100%",
                    marginTop: 10,
                    paddingVertical: 15,
                    justifyContent: "space-between",
                    borderTopColor: "#9cbee7",

                    alignItems: "center",
                    backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                    borderTopWidth: index >= 1 ? 0 : 1,
                  }}
                >
                  <View
                    style={{
                      width: "20%",
                      flexDirection: "row",
                      paddingVertical: 20,
                    }}
                  >
                    <View
                      style={{
                        width: "50%",
                        alignItems: "center",
                      }}
                    >
                      <Text style={styles.textDetail}>
                        {item.event} ({item.gender})
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          if (
                            item.gender == "Male" &&
                            route.params.approbation_details.events_male[
                              item.event
                            ] <=
                              data
                                .filter((e) => {
                                  try {
                                    return e.Athlete.first_name
                                      .toLowerCase()
                                      .includes(text.toLowerCase());
                                  } catch (error) {
                                    return false;
                                  }
                                })
                                .filter((b) =>
                                  b.Athlete.gender
                                    .toLowerCase()
                                    .includes(gender.toLowerCase())
                                )
                                .filter((a) => {
                                  try {
                                    return (
                                      a.best_record.filter((e) => {
                                        return e.event == item.event;
                                      }).length > 0
                                    );
                                  } catch (error) {
                                    return item.Type == "Official";
                                  }
                                })
                                .filter((a) => a.Athlete.gender == item.gender)
                                ?.length
                          ) {
                            setValidate("[Athletes] limit reached. (Limit: x)");
                            setModalVisible(true);
                            setTimeout(() => {
                              setModalVisible(false);
                            }, 2000);
                            return;
                          }
                          if (
                            item.gender != "Male" &&
                            route.params.approbation_details.events_female[
                              item.event
                            ] <=
                              data
                                .filter((e) => {
                                  try {
                                    return e.Athlete.first_name
                                      .toLowerCase()
                                      .includes(text.toLowerCase());
                                  } catch (error) {
                                    return false;
                                  }
                                })
                                .filter((b) =>
                                  b.Athlete.gender
                                    .toLowerCase()
                                    .includes(gender.toLowerCase())
                                )
                                .filter((a) => {
                                  try {
                                    return (
                                      a.best_record.filter((e) => {
                                        return e.event == item.event;
                                      }).length > 0
                                    );
                                  } catch (error) {
                                    return item.Type == "Official";
                                  }
                                })
                                .filter((a) => a.Athlete.gender == item.gender)
                                ?.length
                          ) {
                            setValidate("[Athletes] limit reached. (Limit: x)");
                            setModalVisible(true);
                            setTimeout(() => {
                              setModalVisible(false);
                            }, 2000);
                            return;
                          }

                          const deleteNum = data
                            .filter((e) => {
                              try {
                                return e.Athlete.first_name
                                  .toLowerCase()
                                  .includes(text.toLowerCase());
                              } catch (error) {
                                return false;
                              }
                            })
                            .filter((b) =>
                              b.Athlete.gender
                                .toLowerCase()
                                .includes(gender.toLowerCase())
                            )
                            .filter((a) => {
                              try {
                                return (
                                  a.best_record.filter(
                                    (e) => e.event == item.event
                                  ).length > 0
                                );
                              } catch (error) {
                                return item.Type == "Official";
                              }
                            })
                            .filter(
                              (a) => a.Athlete.gender == item.gender
                            ).length;

                          DATA.filter((val) => {
                            if (item.gender == "Male") {
                              route.params.approbation_details.athlete_male_numbers =
                                route.params.approbation_details.events_male[
                                  item.event
                                ] -
                                data
                                  .filter((e) => {
                                    try {
                                      return e.Athlete.first_name
                                        .toLowerCase()
                                        .includes(text.toLowerCase());
                                    } catch (error) {
                                      return false;
                                    }
                                  })
                                  .filter((b) =>
                                    b.Athlete.gender
                                      .toLowerCase()
                                      .includes(gender.toLowerCase())
                                  )
                                  .filter((a) => {
                                    try {
                                      return (
                                        a.best_record.filter(
                                          (e) => e.event == item.event
                                        ).length > 0
                                      );
                                    } catch (error) {
                                      return item.Type == "Official";
                                    }
                                  })
                                  .filter(
                                    (a) => a.Athlete.gender == item.gender
                                  ).length;
                            } else {
                              route.params.approbation_details.athlete_female_numbers =
                                route.params.approbation_details.events_female[
                                  item.event
                                ] -
                                data
                                  .filter((e) => {
                                    try {
                                      return e.Athlete.first_name
                                        .toLowerCase()
                                        .includes(text.toLowerCase());
                                    } catch (error) {
                                      return false;
                                    }
                                  })
                                  .filter((b) =>
                                    b.Athlete.gender
                                      .toLowerCase()
                                      .includes(gender.toLowerCase())
                                  )
                                  .filter((a) => {
                                    try {
                                      return (
                                        a.best_record.filter(
                                          (e) => e.event == item.event
                                        ).length > 0
                                      );
                                    } catch (error) {
                                      return item.Type == "Official";
                                    }
                                  })
                                  .filter(
                                    (a) => a.Athlete.gender == item.gender
                                  ).length;
                            }
                          });
                          if (
                            item.event != "Officials" &&
                            item.gender == "Male" &&
                            route.params.approbation_details
                              .athlete_male_numbers == 0
                          ) {
                            setValidate("[Athletes] limit reached. (Limit: x)");
                            setModalVisible(true);
                            setTimeout(() => {
                              setModalVisible(false);
                            }, 2000);
                          } else if (
                            item.event != "Officials" &&
                            item.gender == "Female" &&
                            route.params.approbation_details
                              .athlete_female_numbers == 0
                          ) {
                            setValidate("[Athletes] limit reached. (Limit: x)");
                            setModalVisible(true);
                            setTimeout(() => {
                              setModalVisible(false);
                            }, 2000);
                          } else if (
                            item.event == "Official" &&
                            item.gender == "Male" &&
                            route.params.approbation_details
                              .official_male_numbers -
                              deleteNum ==
                              0
                          ) {
                            setValidate(
                              "[Officials] limit reached. (Limit: x)"
                            );
                            setModalVisible(true);
                            setTimeout(() => {
                              setModalVisible(false);
                            }, 2000);
                          } else if (
                            item.event == "Official" &&
                            item.gender == "Female" &&
                            route.params.approbation_details
                              .official_female_numbers -
                              deleteNum ==
                              0
                          ) {
                            setValidate(
                              "[Officials] limit reached. (Limit: x)"
                            );

                            setModalVisible(true);
                            setTimeout(() => {
                              setModalVisible(false);
                            }, 2000);
                          } else {
                            navigation.navigate("FinalEntryAthlete", {
                              competition_id: route.params.competition_id,
                              approbation_details:
                                route.params.approbation_details,
                              approbation_id: route.params.approbation_id,
                              final_entry_athletes: dataSelect,
                              final_entry_officials: dataofficialSelect,
                              name: route.params.name,
                              limit_age_end: route.params.limit_age_end,
                              limit_age_start: route.params.limit_age_start,
                              generation: route.params.generation,
                              type: item.Type,
                              gender: item.gender,
                              event: item.event,
                            });
                          }
                        }}
                        style={{
                          width: 80,
                          height: 40,
                          backgroundColor: "#FFFFFF",
                          borderWidth: 1,
                          borderColor: "#2B6AB1",
                          borderRadius: 33,
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: 20,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 18,
                            fontFamily: "Prompt",
                            color: "#2B6AB1",
                          }}
                        >
                          ADD
                        </Text>
                      </TouchableOpacity>
                    </View>
                    <View
                      style={{
                        width: "50%",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Text style={[styles.textDetail]}>
                        {item.gender == "Male"
                          ? route.params.approbation_details.events_male[
                              item.event
                            ]
                          : route.params.approbation_details.events_female[
                              item.event
                            ]}
                        {item.event == "Official" &&
                          (item.gender == "Male"
                            ? route.params.approbation_details
                                .official_male_numbers
                            : route.params.approbation_details
                                .official_female_numbers)}
                      </Text>
                    </View>
                  </View>
                  <View style={{ width: "80%" }}>
                    {data
                      .filter((e) => {
                        try {
                          return e.Athlete.first_name
                            .toLowerCase()
                            .includes(text.toLowerCase());
                        } catch (error) {
                          return false;
                        }
                      })
                      .filter((b) =>
                        b.Athlete.gender
                          .toLowerCase()
                          .includes(gender.toLowerCase())
                      )
                      .filter((a) => {
                        try {
                          return (
                            a.best_record.filter((e) => {
                              return e.event == item.event;
                            }).length > 0
                          );
                        } catch (error) {
                          return item.Type == "Official";
                        }
                      })
                      .filter((a) => a.Athlete.gender == item.gender)
                      .map((items, indexs) => (
                        <View
                          style={{
                            flexDirection: "row",
                            // paddingHorizontal: 5,
                            width: "100%",
                            marginTop: 10,
                            paddingVertical: 15,
                            justifyContent: "space-between",
                            borderTopColor: "#9cbee7",
                            alignItems: "center",
                            // backgroundColor: indexs % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                            borderTopWidth: indexs == 0 ? 0 : 1,
                          }}
                        >
                          <View style={{ width: "10%" }}>
                            <Image
                              resizeMode={"contain"}
                              style={[styles.imgDetail]}
                              source={{ uri: items.Athlete.image_url }}
                            />
                          </View>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              {
                                width: "15%",
                              },
                            ]}
                          >
                            {items.Athlete.first_name} {items.Athlete.last_name}
                          </Text>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "10%" },
                            ]}
                          >
                            {moment(items.Athlete.birth_date).format(
                              "DD-MM-YYYY"
                            )}
                          </Text>
                          <Text
                            numberOfLines={1}
                            style={[
                              width < 1600
                                ? styles.textDetailRespons
                                : styles.textDetail,
                              { width: "10%" },
                            ]}
                          >
                            {items.Athlete.passport}
                          </Text>
                          <View style={{ width: "12%" }}>
                            {items.best_record != null &&
                              items.best_record.map((e, i) => (
                                <>
                                  <Text
                                    numberOfLines={1}
                                    style={[
                                      width < 1600
                                        ? styles.textDetailRespons
                                        : styles.textDetail,
                                      { width: "100%" },
                                    ]}
                                  >
                                    {e.personal_best_stat}
                                  </Text>
                                  <Text
                                    numberOfLines={1}
                                    style={[
                                      width < 1600
                                        ? styles.textDetailRespons
                                        : styles.textDetail,
                                      { width: "100%" },
                                    ]}
                                  >
                                    {e.personal_best_date}
                                  </Text>
                                  <Text
                                    numberOfLines={1}
                                    style={[
                                      width < 1600
                                        ? styles.textDetailRespons
                                        : styles.textDetail,
                                      { width: "100%" },
                                    ]}
                                  >
                                    {e.personal_best_venue}
                                  </Text>
                                </>
                              ))}
                          </View>
                          <View style={{ width: "10%" }}>
                            {items.best_record != null &&
                              items.best_record.map((e, i) => (
                                <>
                                  <Text
                                    numberOfLines={1}
                                    style={[
                                      width < 1600
                                        ? styles.textDetailRespons
                                        : styles.textDetail,
                                      { width: "100%" },
                                    ]}
                                  >
                                    {e.season_best_stat}
                                  </Text>
                                  <Text
                                    numberOfLines={1}
                                    style={[
                                      width < 1600
                                        ? styles.textDetailRespons
                                        : styles.textDetail,
                                      { width: "100%" },
                                    ]}
                                  >
                                    {e.season_best_date}
                                  </Text>
                                  <Text
                                    numberOfLines={1}
                                    style={[
                                      width < 1600
                                        ? styles.textDetailRespons
                                        : styles.textDetail,
                                      { width: "100%" },
                                    ]}
                                  >
                                    {e.season_best_venue}
                                  </Text>
                                </>
                              ))}
                          </View>
                          <View
                            style={{
                              width: "7%",
                              alignItems: "center",
                            }}
                          >
                            <TouchableOpacity
                              onPress={() => {
                                navigation.navigate("FinalEntryAthleteEdit", {
                                  ...items,
                                  ...route.params,
                                  approbation_details:
                                    route.params.approbation_details,
                                  approbation_id: route.params.approbation_id,
                                  final_entry_athletes: dataSelect,
                                  final_entry_officials: dataofficialSelect,
                                  name: route.params.name,
                                  type: "Athlete",
                                  gender: item.gender,
                                  event: item.event,
                                  best_record: data
                                    .filter(
                                      (val) =>
                                        val.Athlete.last_name ==
                                          items.Athlete.last_name &&
                                        val.Athlete.first_name ==
                                          items.Athlete.first_name &&
                                        val.Athlete.passport ==
                                          items.Athlete.passport
                                    )
                                    .map((vals) => {
                                      if (vals?.best_record?.length > 0) {
                                        return vals.best_record[0];
                                      }
                                    }),
                                });
                              }}
                              style={{
                                width: 80,
                                height: 40,
                                backgroundColor: "#FFFFFF",
                                borderRadius: 33,
                                borderWidth: 1,
                                borderColor: "#2B6AB1",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 20,
                                  fontFamily: "Prompt",
                                  color: "#2B6AB1",
                                }}
                              >
                                EDIT
                              </Text>
                            </TouchableOpacity>
                          </View>
                          <View
                            style={{
                              width: "7%",
                              alignItems: "center",
                            }}
                          >
                            <TouchableOpacity
                              onPress={async () => {
                                const res = await deleteFinalAth({
                                  state: items.id,
                                  token: token.token,
                                });
                                if (res) {
                                  callApi();
                                }
                              }}
                              style={{
                                width: 80,
                                height: 40,
                                backgroundColor: "#ff0000",
                                borderRadius: 33,
                                borderWidth: 1,
                                borderColor: "#ff0000",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              // style={styles.buttomDetail}
                            >
                              <Ionicons
                                name="trash-bin-outline"
                                size={24}
                                color="#fff"
                              />
                            </TouchableOpacity>
                          </View>
                        </View>
                      ))}
                  </View>
                </View>
              );
            }}
          />

          {/* <FlatlistFinal
            user
            data={data
              .filter((e) => {
                try {
                  return e.Athlete.first_name
                    .toLowerCase()
                    .includes(text.toLowerCase());
                } catch (error) {
                  return false;
                }
              })
              .filter((item) =>
                item.Athlete.gender.toLowerCase().includes(gender.toLowerCase())
              )}
            allitem={{
              approbation_details: route.params.approbation_details,
              approbation_id: route.params.approbation_id,
              final_entry_athletes: dataSelect,
              final_entry_officials: dataofficialSelect,
            }}
            route={route}
            name={route.params.name}
            navigation={navigation}
            onPress={() => {
              callApi();
            }}
          /> */}
          <TouchableOpacity
            onPress={async () => {
              setShowModal(!showModal);
            }}
            style={
              width >= 1280
                ? styles.buttonSubmit
                : stylesResponsive.buttonSubmit
            }
          >
            <Text style={styles.textButtonSubmit}>SUBMIT</Text>
          </TouchableOpacity>
        </View>
        <Modal
          transparent={true}
          visible={showModal}
          onRequestClose={() => {
            Alert.alert("Modal has been closed.");
            setShowModal(!showModal);
          }}
        >
          <View style={styles.bgModal}>
            <View
              style={{
                backgroundColor: "#FFFFFF",
                width: "100%",
                maxWidth: 920,
                height: 318,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: "#2B6AB1",
                paddingVertical: 45,
                paddingHorizontal: 20,
                alignItems: "center",
                alignSelf: "center",
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: "Prompt",
                  color: "#C52020",
                  textAlign: "center",
                }}
              >
                Before you submit your entries via the link, please ensure that
                all information are correctly filled, as amendment will not be
                entertained.
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  marginVertical: 50,
                  alignItems: "center",
                }}
              >
                <TouchableOpacity onPress={() => setApprove((val) => !val)}>
                  <MaterialCommunityIcons
                    name={
                      approve ? "checkbox-marked" : "checkbox-blank-outline"
                    }
                    size={24}
                    color="#2B6AB1"
                  />
                </TouchableOpacity>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: "Prompt",
                    color: "#2B6AB1",
                    marginLeft: 20,
                  }}
                >
                  I agree that I have filled up all information correct
                </Text>
              </View>
              <View style={{ flexDirection: "row" }}>
                <TouchableOpacity
                  onPress={async () => {
                    if (
                      (approve && dataSelect.length > 0) ||
                      dataofficialSelect > 0
                    ) {
                      const responseRegister = await approbationsregisterform({
                        body: route.params.competition_id,
                        path: profile.profile.Association.association_id,
                        token: token.token,
                      });
                      body.approbation_id =
                        responseRegister.result.approbation_id;
                      body.final_entry_athletes = dataSelect.filter(
                        (item) => item != false
                      );
                      body.final_entry_officials = dataofficialSelect.filter(
                        (item) => item != false
                      );

                      const response = await registerformfinal({
                        token: token.token,
                        body,
                      });
                      // console.log(response);
                      if (response) {
                        navigation.navigate("CompetitionUser");
                        setShowModal(!showModal);
                      }
                    }
                  }}
                  style={{
                    width: 109,
                    height: 35,
                    backgroundColor: approve ? "#B2FFAC" : "#d2d2d2",
                    borderWidth: 1,
                    borderColor: approve ? "#2BB165" : "#d2d2d2",
                    borderRadius: 5,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      fontFamily: "Prompt",
                      color: approve ? "#2BB165" : "#fff",
                    }}
                  >
                    CONFIRM
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => {
                    setShowModal(!showModal);
                  }}
                  style={{
                    width: 109,
                    height: 35,
                    backgroundColor: "#FFBEBE",
                    borderWidth: 1,
                    borderColor: "#FF4646",
                    borderRadius: 5,
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: 74,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      fontFamily: "Prompt",
                      color: "#FF4646",
                    }}
                  >
                    CANCEL
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  viewModal: {
    width: width * 0.4,
    height: 200,
    backgroundColor: "#FFBEBE",
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 40,
    borderRadius: 38,
  },
  textModal: {
    fontSize: 22,
    fontFamily: "Prompt",
    alignSelf: "center",
    color: "#FF4646",
    textAlign: "center",
  },
  buttomDetail: {
    maxWidth: 65,
    width: "100%",
    height: 40,
    backgroundColor: "#fff",
    borderRadius: 9,
    marginTop: 13,
    justifyContent: "center",
  },
  textButtonDetailRespons: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
  textButtonDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
  bgModal: {
    width: "100%",
    height: "100%",
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  textTopic: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textTopicRespons: {
    fontSize: 13,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
  },
  buttonSubmit: {
    width: 127,
    height: 40,
    backgroundColor: "#FFBC1E",
    borderRadius: 10,
    justifyContent: "center",
    alignSelf: "center",
    marginVertical: height * 0.1,
  },
  textButtonSubmit: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  imgDetail: {
    maxWidth: 120,
    width: "100%",
    height: 120,
    borderRadius: 5,
  },
  textDetailRespons: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
});
const stylesResponsive = StyleSheet.create({
  buttonSubmit: {
    width: 127,
    height: 40,
    backgroundColor: "#FFBC1E",
    borderRadius: 10,
    justifyContent: "center",
    alignSelf: "center",
    marginVertical: 20,
  },
});
